<template>
  <div>
    <template v-if="!isVendorInfoEmpty">
      <CRow class="info-box mt-2" v-if="contact.contact_tg">
        <CCol md="6">
          <h3>
            <CIcon name="cib-telegram" style="color: green;" class="contact-icon" size="lg"/>
            <span class="contact-name">Telegram</span>
          </h3>
        </CCol>
        <CCol md="4" class="info-box">
          <a :href="`https://t.me/${contact.contact_tg}`">
            {{ contact.contact_tg }}
          </a>
        </CCol>
      </CRow>
      <CRow class="info-box mt-2" v-if="contact.contact_email">
        <CCol md="6">
          <h3>
            <CIcon name="cil-envelope-closed" style="color: blue;" class="contact-icon" size="lg"/>
            <span class="contact-name">Email</span>
          </h3>
        </CCol>
        <CCol md="4" class="info-box">
          <a :href="`mailto:${contact.contact_email}`">
            {{ contact.contact_email }}
          </a>
        </CCol>
      </CRow>
      <CRow class="info-box mt-2" v-if="contact.contact_phone">
        <CCol md="6">
          <h3>
            <CIcon name="cil-phone" style="color: purple;" class="contact-icon" size="lg"/>
            <span class="contact-name">{{ $t('contact_us.ContactPhoneLabel') }}</span>
          </h3>
        </CCol>
        <CCol md="4" class="info-box">
          <a :href="`tel:${contact.contact_phone}`">
            {{ contact.contact_phone }}
          </a>
        </CCol>
      </CRow>
    </template>
    <template v-else>
      <p>{{ $t('contact_us.TrustyCDNContactUsContent') }}</p>
    </template>

    <CRow class="info-box mt-2" v-if="isNotTrustyCDN">
      <CCol md="6">
        <h3>
          <CIcon name="cil-location-pin" style="color: blue;" class="contact-icon" size="lg"/>
          <span class="contact-name">{{ $t('contact_us.OfficeAddressLabel') }}</span>
        </h3>
      </CCol>
      <CCol md="6" class="info-box">
        <p style="margin-bottom: 0">{{ $t('contact_us.OfficeAddress') }}</p>
      </CCol>
    </CRow>
  </div>
</template>

<style scoped>
.contact-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.contact-name {
  font-size: 1rem;
  margin-left: 10px;
}

.info-box {
  display: flex;
  align-items: center;
}
</style>

<script>
import { ContactUsMixin } from "@/mixins/ContactUsMixin";

export default {
  name: "Contacts",
  mixins: [ContactUsMixin]
};
</script>
